export default __webpack_public_path__ + "static/media/3.41bf49cd.png";